import React from 'react';
import { IFavorite } from '../../modules/types/selections';
import { FaComment, FaHeart } from 'react-icons/fa';
import { UncontrolledTooltip } from 'reactstrap';
import styled from 'styled-components';
import { CommentCountBadge } from './CommentCountBadge';
import { useImageCardFavoritesIcons } from './hooks/useImageCardFavoritesIcons';

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: 2px;
  z-index: 3;

  svg {
    position: initial;
    margin-left: 5px;
  }
`;

const CommentBadgeWrapper = styled.div<{ $isBelowTitleIcon: boolean }>`
  position: absolute;
  right: 12px;
  /* Title-image tiles already own the top-right corner with the star icon. */
  top: ${({ $isBelowTitleIcon }) => ($isBelowTitleIcon ? '28px' : '2px')};
  z-index: 3;
`;

interface IProps {
  favorite?: IFavorite;
  imageId?: string;
  commentCount?: number;
  onCommentClick?: (imageId: string) => void;
  isTitleImage?: boolean;
}

export const ImageCardFavoritesIcons = ({
  favorite,
  imageId,
  commentCount = 0,
  onCommentClick,
  isTitleImage
}: IProps) => {
  const { like, showLegacyComment, showCommentBadge, isEmpty } = useImageCardFavoritesIcons({
    favorite,
    imageId,
    commentCount,
    onCommentClick
  });

  if (isEmpty) return null;

  return (
    <>
      {favorite && (
        <Wrapper>
          {like && <FaHeart color="#f64846" size={20} />}

          {showLegacyComment && (
            <>
              <FaComment color="#7b7b7b" size={20} id={`favorite_comment_${favorite._id}`} />
              <UncontrolledTooltip
                autohide={false}
                placement="top"
                target={`favorite_comment_${favorite._id}`}
              >
                {favorite.comment}
              </UncontrolledTooltip>
            </>
          )}
        </Wrapper>
      )}

      {showCommentBadge && (
        <CommentBadgeWrapper $isBelowTitleIcon={Boolean(isTitleImage)}>
          <CommentCountBadge
            imageId={imageId}
            commentCount={commentCount}
            onClick={onCommentClick}
          />
        </CommentBadgeWrapper>
      )}
    </>
  );
};
